import { render } from "./SendAgent.vue?vue&type=template&id=c00235e2"
import script from "./SendAgent.vue?vue&type=script&lang=js"
export * from "./SendAgent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__